import Icon from "./icons";

export default Icon;
